import React, { useEffect, useState } from "react";
import { axiosInstance } from "../constant";
import CatagoryCard from "../component/CatagoryCard";
import { Pagination } from "@mui/material";
import Loading from "../component/Loading";

function CatagoryPage() {
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [catagoryData, setCatagoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // get catagory
  async function getCatagories() {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `/api/v1/product/catagory/get/all/${page}/50`
      );
      console.log(res.data?.data);
      setCatagoryData(res.data?.data?.data);
      setTotalPages(res.data?.data?.totalPages);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Something went wrong");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  function handlePageChange(event, value) {
    setPage(value);
  }

  useEffect(() => {
    getCatagories();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="w-full flex flex-col justify-center items-center mt-[5rem]">
        {success !== undefined && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <h1 className="text-center heading_text mt-[5rem] uppercase text-[40px] font-extrabold text-orange-700 tracking-wide">
          Our All products
        </h1>
        <div className="w-[90vw] mt-[3rem] py-5">
          <div className="w-full grid grid-cols-3 text-center md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 place-items-center items-start gap-[3rem]">
            {catagoryData?.map((catagory, i) => (
              <CatagoryCard title={catagory?.name} url={catagory?.image} />
            ))}
          </div>
        </div>
        <div className="w-full flex justify-center items-center py-5">
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            className="!font-semibold"
          />
        </div>
      </div>
    </>
  );
}

export default CatagoryPage;
